export default __webpack_public_path__ + "static/media/uploader-abbottLibre-problem-2.bced27f0.png";